import React from 'react';
import { ff } from '@atlassian/jira-feature-flagging';
import { useFormContext } from '@atlassian/jira-issue-create-form-context';
import { IssueRestore, type IssueRestoreChildren } from '@atlassian/jira-issue-create-restore';
import { useTriggerIssueCreateModal } from '@atlassian/jira-packages-controllers-use-trigger-issue-create-modal';
import { useIsEmbedded } from '@atlassian/jira-platform-react-hooks-use-is-embedded';

type IssueRestoreWrapperProps = {
	children?: IssueRestoreChildren;
};

export const IssueRestoreWrapper = ({ children }: IssueRestoreWrapperProps) => {
	const [, { restoreState: restoreTriggerIssueCreateModalState }] = useTriggerIssueCreateModal();
	const [, { restoreState: restoreFormContext }] = useFormContext();
	const isEmbedded = useIsEmbedded();

	return ff('avoid-issue-restore-wrapper-for-issue-create-embed_rs3rb') && isEmbedded ? (
		<>{children?.({})}</>
	) : (
		<IssueRestore
			onRestoreTriggerIssueCreateModalState={restoreTriggerIssueCreateModalState}
			onRestoreFormContext={restoreFormContext}
		>
			{children}
		</IssueRestore>
	);
};
